import { Box, Text } from "@chakra-ui/react";
import { getUser } from "../../libs/auth"
import { Emissor as IEmissor } from "../../utils/interfaces";

interface Props {
  emissor: IEmissor
}

export function Emissor({emissor}: Props){
  const user = getUser();

  return (
    <Box w={'500px'} bg={'#f4f4f4'} p={'2'} display={'flex'} flexDir={'column'}>
      <Text fontWeight={'bold'}>Detalhes do Emissor</Text>
      <Text fontSize={'small'}>Nome: {user.name}</Text>
      <Text fontSize={'small'}>Email: {user.email}</Text>
      <Text fontSize={'small'}>Empresa: {emissor.nome}</Text>
      <Text fontSize={'small'}>Financeiro: {emissor.email_financeiro}</Text>
    </Box>
  )
}